// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3SJyE","title":"Header_title__3rKWd","desc":"Header_desc__3HpXP"};